export function xeroNeedsReconnect(config) {
  if (!config?.connected) return false;
  return config?.connectionStatus === 'reconnect_required'
    || /refresh token|invalid_grant|not connected|authorisation has expired|no longer authoris|access .*lost/i.test(config?.lastConnectionError || config?.lastSyncError || '');
}

export function xeroRateLimited(config) {
  return Boolean(config?.connected && config?.syncPause?.reason === 'rate_limit');
}

export function xeroSyncNotice(result) {
  const summary = `${result.succeeded || 0} records synced; ${result.waiting || 0} waiting for Stripe; ${result.remaining || 0} jobs queued; ${result.failedJobs ?? 0} need attention.`;
  return result.deferred ? `${summary} Xero has paused requests; queued records will resume automatically.` : summary;
}

export function xeroHealthWarning(config, now = Date.now()) {
  if (!config?.connected) return '';
  if (xeroNeedsReconnect(config)) return 'Reconnect Xero to restore access and resume syncing.';
  if (config.connectionStatus === 'selection_required') return 'Choose a Xero organisation and save the settings to start syncing.';
  if (config.syncMode === 'disabled') return 'Xero sync is disabled. Save the Xero settings to enable automatic syncing.';
  if (config.queueSummary?.failed > 0) return 'Some Xero records failed to sync. Review the latest error, resolve it and run Sync now to retry.';
  if (xeroRateLimited(config)) {
    const resume = config.syncPause.resumeAt?.toDate?.() || config.syncPause.resumeAt;
    const time = resume instanceof Date && resume.getTime() > now ? ` from ${resume.toLocaleString()}` : ' shortly';
    return `Sync is waiting for Xero’s request allowance. Your records are queued and will resume automatically${time}. You do not need to reconnect.`;
  }
  if (config.lastConnectionError || config.lastSyncError) return 'Xero needs attention. Check the error below before relying on your accounts being up to date.';
  const lastCheck = config.lastConnectionCheckAt || config.lastSyncAt || config.connectedAt;
  const date = lastCheck?.toDate?.() || (lastCheck instanceof Date ? lastCheck : null);
  if (!date || now - date.getTime() > 48 * 60 * 60 * 1000) {
    return 'Automatic sync has not been verified in the last 48 hours. Run Sync now and check the connection before relying on your accounts being up to date.';
  }
  return '';
}
